import React, { useEffect, useContext } from 'react';
import Button from '../../../../components/UI/Button';
import { getPlanNameText } from '../helpers';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';

export default function ContinueWithoutCredit({ planName, moveToFundWallet }) {
  const { analytics } = useContext(AnalyticsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.page('Registration', 'Continue with Greenlight without FCC');
  }, []);

  const planNameText = getPlanNameText(planName);
  return (
    <>
      <h1 data-testid="continue-without-credit-header">{`Continue with ${planNameText}`}</h1>
      <h2>
        {`You still have a 1-month free trial of ${planNameText}. With this plan, you can get debit cards for your kids, send them money, set up chores, and more. `}
      </h2>
      <Button
        text="Continue"
        onClick={() => {
          analytics.trackEvent('Credit Action', {
            eventProps: {
              type: 'Continue',
              page: 'Continue with Greenlight without FCC'
            }
          });
          moveToFundWallet();
        }}
      />
    </>
  );
}
